import React, { useState } from "react";
import Layout from "../layout/Layout";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { login } from "../../actions/auth";
import { Redirect } from "react-router-dom";
import { Button, Flex, Form, Input, Select, Tabs } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";

// todos los props deben estar como argumentos en la funcion principal
const Signin = ({ login, isAuthenticated, user, history }) => {
	const [loading, setLoading] = useState(false);
	const [loginType, setLoginType] = useState("email");
	const [form] = Form.useForm();

	const clickSubmit = async (values) => {
		setLoading(true);
		// llamar action/reducer:
		await login(values.credential, values.password, setLoading);
		setLoading(false);
	};

	const handleTabChange = (key) => {
		setLoginType(key);
		// Clear the credential field when switching tabs
		form.setFieldsValue({ credential: "" });
	};

	// Email validation regex
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	// Phone validation regex (supports formats like: +1234567890, 123-456-7890, (123) 456-7890, etc.)
	const phoneRegex =
		/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;

	const getValidationRules = () => {
		if (loginType === "email") {
			return [
				{
					required: true,
					message: "Please input your email!",
				},
				{
					pattern: emailRegex,
					message: "Please enter a valid email address!",
				},
			];
		} else {
			return [
				{
					required: true,
					message: "Please input your phone number!",
				},
				{
					pattern: phoneRegex,
					message: "Please enter a valid phone number!",
				},
			];
		}
	};

	const tabItems = [
		{
			key: "email",
			label: (
				<span>
					<MailOutlined /> Email
				</span>
			),
		},
		{
			key: "phone",
			label: (
				<span>
					<PhoneOutlined /> Phone
				</span>
			),
		},
	];

	const redirectForgotPassword = () => {
		history.push("/forgot-password");
	};

	const LoginForm = () => (
		<>
			<Tabs
				items={tabItems}
				activeKey={loginType}
				onChange={handleTabChange}
				centered
				style={{ marginBottom: 20 }}
			/>
			<Form
				form={form}
				layout="vertical"
				name="signin"
				onFinish={clickSubmit}
				autoComplete="on"
			>
				<Form.Item
					label={loginType === "email" ? "Email" : "Phone Number"}
					name="credential"
					rules={getValidationRules()}
				>
					<Input
						size="large"
						autoComplete="on"
						placeholder={
							loginType === "email"
								? "Enter your email"
								: "Enter your phone number"
						}
						prefix={
							loginType === "email" ? <MailOutlined /> : <PhoneOutlined />
						}
					/>
				</Form.Item>

				<Form.Item
					label="Password"
					name="password"
					rules={[
						{
							required: true,
							message: "Please input your password!",
						},
						{
							min: 5,
							message: "Password must be at least 5 characters!",
						},
					]}
				>
					<Input.Password size="large" autoComplete="on" />
				</Form.Item>
				<Flex justify="center" vertical>
					<Button
						type="primary"
						htmlType="submit"
						size="large"
						loading={loading}
					>
						Access
					</Button>
					<Button
						type="link"
						disabled={loading}
						onClick={redirectForgotPassword}
					>
						Forgot Password?
					</Button>
				</Flex>
			</Form>
		</>
	);

	// mandar un redirect cuando el usuario ya esta autorizado.
	if (isAuthenticated) {
		localStorage.setItem("role", user.role);
		const userId = localStorage.getItem("userId");

		if (user.role === "Customer") {
			return <Redirect to={`/dailycustomer/${userId}`} />;
		} else if (user.role === "Mechanic") {
			return <Redirect to={`/workorders/${userId}`} />;
		} else if (user.email === "office@castlereadymix.com") {
			return <Redirect to="/logistics/dashboard" />;
		} else {
			return <Redirect to="/dailyappointment" />;
		}
	}

	return (
		<Layout title="Sign in" description="Sign in" type="small">
			{LoginForm()}
		</Layout>
	);
};

Signin.propTypes = {
	login: PropTypes.func.isRequired,
	// isAuthenticated: PropTypes.bool.isRequired,
	// user: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	isAuthenticated: state.auth.isAuthenticated,
	user: state.auth.usuario,
});

export default connect(mapStateToProps, { login })(Signin);
